import type { PersonId } from '@fs/zion-tree-types'
import { type ComponentProps } from 'react'
import type OrdinancePersonView from '@fs/zion-person-ordinance-view'
import { useSwrRequest } from './useSwrRequest'

export type PrimaryParents = NonNullable<ComponentProps<typeof OrdinancePersonView>['primaryParents']>

export const primaryParentsUrl = (personId: PersonId): string =>
  `/service/tree/tree-data/v8/person/${personId}/parents-ids`

const hasBothParents = ({ parent1Id, parent2Id }: PrimaryParents): boolean =>
  !!parent1Id && parent1Id !== 'UNKNOWN' && !!parent2Id && parent2Id !== 'UNKNOWN'

/** The preferred family with both parents, or else the first one with both parents. */
export function getPrimaryParents(parentsIds: PrimaryParents[] | undefined): PrimaryParents | undefined {
  return parentsIds?.find((parents) => parents.preferred && hasBothParents(parents)) ?? parentsIds?.find(hasBothParents)
}

export default function usePrimaryParents(personId?: PersonId): PrimaryParents | undefined {
  const { data: parentsIds } = useSwrRequest<PrimaryParents[]>(personId ? primaryParentsUrl(personId) : null)
  return getPrimaryParents(parentsIds)
}
